import { Component } from '@angular/core'

@Component({
  selector: 'app-groups-page',
  templateUrl: './groups-page.component.html',
  styleUrls: ['./groups-page.component.scss'],
  standalone: false,
})
export class GroupsPageComponent {

  constructor() {
    // noop
  }

}
